import React from 'react'
import { FaHome, FaAngleDown, FaAngleUp,FaTable, FaEnvelope, 
    FaShoppingCart, FaCalculator, FaUserAlt, 
    FaTree, FaCrop, FaPlus, FaLock, FaEye,
    FaAngleLeft
} from 'react-icons/fa'

export default {
    HomeIcon: <FaHome size={16} color={`#666`} />,
    DownIcon: <FaAngleDown size={16} color={`#666`} />,
    UpIcon: <FaAngleUp size={16} color={`#666`} />,
    TableIcon: <FaTable size={16} color={`#666`} />,
    EnvelopeIcon: <FaEnvelope size={16} color={`#666`}/>,
    ShoppingIcon: <FaShoppingCart size={16} color={`#666`}/>,
    CalculatorIcon: <FaCalculator size={16} color={`#666`}/>,
    UserIcon: <FaUserAlt size={16} color={`#666`} />,
    TreeIcon: <FaTree size={16} color={`#666`} />,
    CropIcon: <FaCrop size={16} color={`#666`} />,
    PlusIcon: <FaPlus size={16} color={`#666`} />,
    LockIcon: <FaLock size={16}  color={`#1dab47`} />,
    EmailIcon: <FaUserAlt size={16} color={`#1dab47`} />,
    EyeIcon: <FaEye size={16} color={`#1dab47`} />,
    BackIcon: <FaAngleLeft size={16} color={`#1dab47`} />
}